// 使用相对路径，通过Nginx代理访问后端API
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

// 可根据需要扩展非流式接口

export const InterviewChatAPI = {
  /**
   * 发起流式对话
   * @param {Object} data - 请求负载
   * @param {Function} onMessage - 单个内容块回调
   * @param {Function} onComplete - 完成回调
   * @param {Function} onError - 错误回调
   */
  sendMessageStream: async (data, onMessage, onComplete, onError, signal) => {
    // 根据面试类型选择不同的API端点
    const interviewType = data.interview_config?.interviewType || 'job';
    const apiPrefix = interviewType === 'custom' ? '/api/v1/custom-interview' : '/api/v1/mock-interview';
    const url = `${API_BASE_URL}${apiPrefix}/chat/stream`;
    const processLine = (line) => {
      if (!line.startsWith('data: ')) return false;
      const jsonStr = line.slice(6).trim();
      if (!jsonStr) return false;
      if (jsonStr === '[DONE]') return true;
      try {
        const parsed = JSON.parse(jsonStr);
        if (parsed.choices && parsed.choices[0]?.delta?.content) {
          // OpenAI / Qwen 类似格式
          const content = parsed.choices[0].delta.content;
          onMessage && onMessage({ type: 'text', content });
        } else if (parsed.type === 'text' && parsed.content) {
          onMessage && onMessage({ type: 'text', content: parsed.content });
        } else if (parsed.type === 'tool_call' && parsed.tool_call) {
          // 工具调用
          onMessage && onMessage({ type: 'tool_call', tool_call: parsed.tool_call });
        }
      } catch (e) {
      }
      return false;
    };

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('access_token') || ''}`,
        },
        signal,
        body: JSON.stringify(data),
      });

      if (!response.ok) throw new Error(`请求失败: ${response.status}`);
      if (!response.body) throw new Error('响应无数据流');

      const reader = response.body.getReader();
      const decoder = new TextDecoder('utf-8');
      let buffer = '';

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;
        buffer += decoder.decode(value, { stream: true });
        let idx;
        while ((idx = buffer.indexOf('\n')) !== -1) {
          const line = buffer.slice(0, idx);
          buffer = buffer.slice(idx + 1);
          if (line.trim()) {
            const finished = processLine(line.trim());
            if (finished) {
              onComplete && onComplete();
              return;
            }
          }
        }
      }
      onComplete && onComplete();
    } catch (err) {
      onError && onError(err);
    }
  },
};